import { z } from 'zod';

/**
 * Wire schema for POST /api/client-error (SIL-666). Shared between the
 * frontend reporters (React ErrorBoundary + router errorComponent, both
 * portals — see packages/shared/src/ui/ErrorBoundary.tsx and
 * packages/shared/src/telemetry/report-client-error.ts) and the API route
 * (apps/api/src/routes/client-error.ts), so the two sides never drift.
 *
 * Every string field is length-capped. This endpoint is an unauthenticated
 * trust boundary — any caller on the internet can POST here, not just the
 * two portals — so an unbounded field would be a free log-storage/DoS
 * vector on its own, independent of the request-body-size cap the route
 * enforces before this schema ever runs.
 */
export const clientErrorReportSchema = z.object({
  message: z.string().min(1).max(2000),
  name: z.string().max(200).optional(),
  stack: z.string().max(8000).optional(),
  componentStack: z.string().max(8000).optional(),
  url: z.string().max(2000).optional(),
  userAgent: z.string().max(500).optional(),
  portal: z.enum(['operations', 'customer']),
  source: z.enum(['error-boundary', 'router-error']),
});
export type ClientErrorReport = z.infer<typeof clientErrorReportSchema>;
